import { registerFunctionalComponent } from 'js/lib/components/component'
import { on } from 'js/lib/events'
import { createAnalyticsGroup } from 'js/lib/analytics'

registerFunctionalComponent('.js-c-payments-checkout-form', 'CheckoutFormComponent', CheckoutFormComponent)

function CheckoutFormComponent(component) {
  const wrapper = component.element
  const frameKey = wrapper.dataset.frameKey
  const track = createAnalyticsGroup('new stepped payment form')
  let lastTrackedStep = null

  const trackCurrentStep = () => {
    const currentStep = wrapper.querySelector('.js-c-payments-checkout-form__current-step')
    if (!currentStep) return

    const { flow, step } = currentStep.dataset
    const currentKey = `${flow}:${step}`
    const completedSteps = (currentStep.dataset.completedSteps || '').split(' ').filter(Boolean)
    if (currentKey === lastTrackedStep) return

    if (lastTrackedStep) {
      const [previousFlow, previousStep] = lastTrackedStep.split(':')
      if (previousFlow === flow && isForwardTransition(wrapper, previousStep, step) && completedSteps.includes(previousStep)) {
        track('payment_step_complete', `${flow}:${previousStep}`)
      }
      wrapper.querySelector('[data-step-progress-step][aria-current="step"]')?.focus({ preventScroll: true })
    }

    lastTrackedStep = currentKey
    track('payment_step_view', currentKey)
  }

  trackCurrentStep()

  const removeRequestEndListener = on('dynamic-frame:request-end', document, event => {
    const { frameKey: updatedFrameKey, status } = event.detail || {}
    if (updatedFrameKey === frameKey && status === 'succeeded') trackCurrentStep()
  })
  const stepObserver = new MutationObserver(trackCurrentStep)
  stepObserver.observe(wrapper, { childList: true, subtree: true })

  component.useHandler(() => () => {
    stepObserver.disconnect()
    removeRequestEndListener()
  })
}

function isForwardTransition(wrapper, previousStep, currentStep) {
  const steps = [...wrapper.querySelectorAll('[data-step-progress-step]')].map(
    heading => heading.dataset.stepProgressStep
  )
  return steps.indexOf(currentStep) > steps.indexOf(previousStep)
}
